var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draw-thumb"},[(_vm.image)?_c('img',{ref:"bgImage",staticClass:"bg-image",class:{ pa: !!_vm.sketch }}):_vm._e(),(_vm.sketch)?_c('img',{ref:"sketchImage",staticClass:"sketch-image"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }